// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Ry32","clinicsSelect":"TableHeading_clinicsSelect__NKR0I"};